import React from "react";
import { CustomTitleLabel } from "./CustomBaseComponments";
import {
  DISPLAY_EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE
} from "config/CustomEnums";
import './LineItemGroupsDetail.scss';

const MinPerLineItem = ({
  title,
  value,
}) => (
  <div className="line-item-group-detail-per-min">
    <CustomTitleLabel className="line-item-group-detail-per-min-title" title={title} />
    <label className="list-new-line">{value || "-"}</label>
  </div>
)

const SingleRequirement = ({
  requirement
}) => {
  const fieldType = requirement?.fieldType;
  if ([
    EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand,
    EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category,
    EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory
  ].includes(fieldType)) {
    return (
      <div className="line-item-group-detail-single-requirement">
        <span>
          {`${DISPLAY_EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE[fieldType]}: ${requirement?.data?.name}`}
        </span>
      </div>
    )
  }

  if ([
    EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData,
    EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData
  ].includes(fieldType)) {
    return (
      <div className="line-item-group-detail-single-requirement">
        <span>
          {`${requirement?.data?.field?.fieldName}: ${requirement?.data?.value}`}
        </span>
      </div>
    )
  }

  if (fieldType === EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku) {
    return (
      <div className="line-item-group-detail-single-requirement">
        <span>
          {`${DISPLAY_EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE[fieldType]}: ${requirement?.data}`}
        </span>
      </div>
    )
  }
}

const SingleLineItemGroupDetail = ({
  index,
  data,
  group,
}) => {
  return (
    <>
      {index !== 0 &&
        <div className="line-item-group-detail-relationship-container">
          <span>{data?.lineITemGroupsUseOr ? "OR" : "AND"}</span>
        </div>
      }
      <CustomTitleLabel className="line-item-group-detail-single-group-title" title={`Line item group ${index + 1}`} />
      <div className="line-item-group-detail-single-group-container">
        {
          group?.requirements?.map((item, subIndex) => (
            <>
              {
                subIndex !== 0 && (
                  <CustomTitleLabel className="line-item-group-detail-single-group-and" title="And" />
                )
              }
              <SingleRequirement requirement={item} />
            </>
          ))
        }
        <div className="line-item-group-detail-single-group-per-container">
          <CustomTitleLabel title="Per line item" />
          <MinPerLineItem
            title="Minimum spending (optional)"
            value={group?.minimumSpending}
          />
          <MinPerLineItem
            title="Minimum quantity (optional)"
            value={group?.minimumQuantity}
          />
        </div>
      </div>
    </>
  )
}

const LineItemGroupsDetail = ({
  data,
}) => {
  if (!data.lineItemRequirement) {
    return null;
  };

  return (
    <div>
      <CustomTitleLabel title="Transaction" />
      <div className="line-item-group-detail-transaction-container">
        {data?.lineItemGroups?.map(
          (group, index) => (
            <SingleLineItemGroupDetail
              key={group.pk}
              index={index}
              data={data}
              group={group}
            />
          )
        )}
      </div>
    </div>
  );
}

export default LineItemGroupsDetail;
